<template>
  <div id="popup-wrap">
    <van-popup v-model="isService" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">绑定微信管理员</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel" />
        </div>
        <div class="popup-content">
          <div class="qrcode-server">
            <img :src="service_code" alt="">
            <div>微信二维码</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Service",
  data: function() {
    return {
      isService: false,
      service_code: '',
      loading: false,
    }
  },
  methods: {
    init: function(isService, code) {
      this.loading = true
      this.service_code = code
      this.isService = isService
      this.loading = false
    },
    handelCancel: function (){
      this.isService = false
    }
  }
}
</script>

<style lang="less" scoped>
.qrcode-server{
  font-family: Alibaba-PuHuiTi-M;
  text-align: center;
  margin: 10px 0 5px;
  font-size: 16px;
  color: #222222;
  img{
    width: 150px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/set/modal/Service.vue